import { render, staticRenderFns } from "./top-notice.vue?vue&type=template&id=2ac2b51e&scoped=true&"
import script from "./top-notice.vue?vue&type=script&lang=js&"
export * from "./top-notice.vue?vue&type=script&lang=js&"
import style0 from "./top-notice.vue?vue&type=style&index=0&id=2ac2b51e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac2b51e",
  null
  
)

export default component.exports